import callApi from 'services'

export default {
  getSiteList() {
    return callApi('sites', 'GET')
  },
}
